import { useMemo } from "react";

import { useGetProjectsQuery } from "@tudigo-monorepo/web-tudigo-api-client";

import { getRandomProjects } from "../../search-finished-projects-page/utils/get-random-projects.utils";
import { sortProjectsByMinGoalDESC } from "../../search-finished-projects-page/utils/sort-projects-by-min-goal-desc.utils";

export const useFinishedSuggestedProjects = (limit: number) => {
  const { data, isFetched, isFetching } = useGetProjectsQuery({
    filters: { status: "finished", isReferenced: true },
    fields:
      "id,impact_score_in_percent,bonds_mechanic_settings,shares_mechanic_settings,tax_exemption_mechanics,total_amount_collected_in_cents,fundraising_progress_min_goal,categories,mechanic,tags,finished_at,marketing_settings,scheduled_end_date,status,goal,maturity,is_referenced,informations,content.fields(name,short_description,slug,cover,logo),club.fields(id,icon_border_color,content.fields(logo),my_membership.fields(status))",
    pagination: { limit: limit },
  });

  const finishedProjects = data?.data;

  const suggestedProjects = useMemo(() => {
    if (!isFetched) return [];

    const referencedProjects = finishedProjects?.filter(
      (project) => project.isReferenced,
    );

    const sortedProjectsByMinGoal =
      sortProjectsByMinGoalDESC(referencedProjects);

    const randomProjects = getRandomProjects(sortedProjectsByMinGoal ?? []);

    return sortProjectsByMinGoalDESC(randomProjects) ?? [];
  }, [finishedProjects, isFetched]);

  return {
    suggestedProjects,
    isFetching,
  };
};
